export default __webpack_public_path__ + "static/media/me.957be31b.svg";